import { Dispatcher } from 'flux';
import { IS_PRODUCTION } from 'src/environment';

const flux = new Dispatcher();

export class AppDispatcher {
  static register(callback) {
    return flux.register(callback);
  }

  // Some Flux examples have methods like `handleViewAction`
  // or `handleServerAction` here. They are only useful if you
  // want to have extra pre-processing or logging for such actions,
  // but I found no need for them.
  static waitFor(ids) {
    return flux.waitFor(ids);
  }

  /**
   * Dispatches a single action.
   */
  static dispatch(type, action = {}) {
    if (!type) {
      throw new Error('You forgot to specify type.');
    }

    if (!IS_PRODUCTION) {
      //   // Logging all actions is useful for figuring out mistakes in code.
      //   // All data that flows into our application comes in form of actions.
      //   // Actions are just plain JavaScript objects describing “what happened”.
      //   // Think of them as newspapers.
      if (action.error) {
        console.error('[ACTION]', type, action);
      }
    }

    flux.dispatch({ type, ...action });
  }
  /**
   * Dispatches three actions for an async operation represented by promise.
   */
  static dispatchAsync(promise, types, action = {}) {
    const { request, success, failure } = types;

    dispatch(request, action);
    promise.then(
      (response) => dispatch(success, { ...action, response }),
      (error) => dispatch(failure, { ...action, error }),
    );
  }
}

export const register = AppDispatcher.register;
export const waitFor = AppDispatcher.waitFor;
export const dispatch = AppDispatcher.dispatch;
export const dispatchAsync = AppDispatcher.dispatchAsync;
